import { makeContextModule } from '@cian/react-utils';

import { IApplicationContext } from 'shared/context/applicationContext/types';

export const {
  Context: ApplicationContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
